import {
  columnFilteringFeature,
  columnVisibilityFeature,
  createFilteredRowModel,
  createSortedRowModel,
  filterFn_equals,
  filterFn_includesString,
  globalFilteringFeature,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_datetime,
  sortFn_text,
  tableFeatures,
} from '@tanstack/react-table';

/**
 * Gemeinsamer TanStack-Table-Feature-Satz aller Dashboard-Tabellen.
 *
 * Ab v9 wird jede Tabellen-Funktion explizit registriert; nicht registrierte
 * Features existieren auf der Tabellen-Instanz nicht. Die Registries `sortFns`
 * und `filterFns` legen zugleich fest, welche String-Namen eine Spalte in
 * `sortFn` bzw. `filterFn` verwenden darf.
 *
 * `alphanumeric`, `text` und `datetime` sind Pflicht, weil Spalten ohne
 * eigenes `sortFn` auf `'auto'` zurückfallen und genau diese drei Namen
 * nachschlagen — ein fehlender Eintrag fällt still auf `basic` zurück und
 * ändert damit die Sortierreihenfolge.
 *
 * `columnVisibilityFeature` trägt `row.getVisibleCells()`, das in v8 noch
 * Teil des Kerns war.
 *
 * @example
 * ```ts
 * const columnHelper = createColumnHelper<DashboardTableFeatures, Person>();
 * const table = useTable({ features: dashboardTableFeatures, columns, data });
 * ```
 */
export const dashboardTableFeatures = tableFeatures({
  columnFilteringFeature,
  columnVisibilityFeature,
  globalFilteringFeature,
  rowSortingFeature,
  filteredRowModel: createFilteredRowModel(),
  sortedRowModel: createSortedRowModel(),
  filterFns: {
    equals: filterFn_equals,
    includesString: filterFn_includesString,
  },
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    datetime: sortFn_datetime,
    text: sortFn_text,
  },
});

/** Typ des Dashboard-Feature-Satzes — erster Typparameter aller Table-Typen. */
export type DashboardTableFeatures = typeof dashboardTableFeatures;
